import styled from '@emotion/styled';
import { Button, FormField, SpaceDivider, Text } from '@innovationdepartment/proxima-ui';
import { brandCategoryOptions } from 'constants/brandCategories';
import { useFormState } from 'react-final-form';
import type { CreateBrandModalFormValues, CreateBrandModalViewProps } from './types';

const ContentWrapper = styled.div`
  width: 100vw;
  max-width: 480px;
  padding: 24px;
`;

const CreateBrandModalView = (_props: CreateBrandModalViewProps) => {
  const formState = useFormState<CreateBrandModalFormValues>();

  const { hasValidationErrors, pristine, submitting, submitFailed, dirtyFieldsSinceLastSubmit } =
    formState;

  const disable =
    pristine ||
    hasValidationErrors ||
    submitting ||
    (submitFailed &&
      !!dirtyFieldsSinceLastSubmit &&
      !['website', 'name'].every(field => field in dirtyFieldsSinceLastSubmit));

  return (
    <ContentWrapper>
      <Text variant="h4">Set up new account</Text>
      <SpaceDivider y={4} />
      <FormField
        label="Brand name"
        type="input"
        fullWidth
        placeholder="Brand name"
        name="name"
        size="medium"
      />
      <SpaceDivider y={2} />
      <FormField
        label="Brand URL"
        type="input"
        fullWidth
        placeholder="Brand URL"
        name="website"
        size="medium"
      />
      <SpaceDivider y={2} />
      <FormField
        placeholder="Primary Category"
        label="Primary Category"
        type="select"
        fullWidth
        name="category"
        size="medium"
        options={brandCategoryOptions}
      />
      <SpaceDivider y={2} />
      {!disable && (
        <Text variant="body2" color="red40">
          After creating a brand, you&rsquo;ll need to invite additional users from the brand
          overview page to grant your team access. Currently, you are the only user with access to
          the brand.
        </Text>
      )}
      <SpaceDivider y={4} />
      <Button submit fullWidth disabled={disable} label="Create" size="medium" />
    </ContentWrapper>
  );
};

export default CreateBrandModalView;
